
import { Component, Vue } from 'vue-property-decorator';
// import TopNavbar from '../components/navigation/TopNavbar.vue';

@Component({
    components: {
   //     TopNavbar,
    },
})
export default class AnonymousRoot extends Vue {
    created() {
        this.$store.state.appLoaded = true;
    }
}
